import { useMergeRefs } from '@floating-ui/react';
import * as React from 'react';
import { usePopoverContext } from './PopoverLogic';

/*
  Richard comment:
  99% of this is just from floating ui example
  some of it is overkill, but it's easier to just copy and use in our app
*/

export const VoxelPopoverTrigger = React.forwardRef<
  HTMLElement,
  React.HTMLProps<HTMLElement> & PopoverTriggerProps
>(function PopoverTrigger({ children, enableActive, ...props }, propRef) {
  const context = usePopoverContext();
  const childrenRef = (children as any).ref;
  const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef]);

  // `asChild` allows the user to pass any element as the anchor
  if (React.isValidElement(children)) {
    return React.cloneElement(
      children,
      context.getReferenceProps({
        ref,
        ...props,
        ...children.props,
        active: !enableActive ? undefined : context.open,
        'data-state': context.open ? 'open' : 'closed',
      })
    );
  }

  return null;
});
export interface PopoverTriggerProps {
  children: React.ReactNode;
  enableActive?: boolean;
}
